// TaskStatusChip — MD3 Chip с цветом по статусу задачи.
// Цвета согласованы с MD3: NEW=primary (синий), IN_PROGRESS=warning (оранжевый),
// DONE=success (зелёный), BLOCKED=error (красный), CANCELLED=нейтральный (серый).
// R41 / U-16: подпись статуса через i18n (formatTaskStatus, ключи tasks.status.*).
import { Chip } from '@mui/material';
import type { TaskStatus } from '@/api/tasks';
import { t } from '@/i18n';
import { formatTaskStatus } from '@/lib/format';

/** Сопоставление статуса → MD3 color. */
const STATUS_COLORS: Record<TaskStatus, 'primary' | 'warning' | 'success' | 'error' | 'default'> = {
  NEW: 'primary',
  IN_PROGRESS: 'warning',
  BLOCKED: 'error',
  DONE: 'success',
  CANCELLED: 'default',
};

interface TaskStatusChipProps {
  /** Статус задачи. */
  status: TaskStatus;
  /** Размер чипа (small по умолчанию). */
  size?: 'small' | 'medium';
}

/** MD3 Chip для отображения статуса задачи. */
export function TaskStatusChip({ status, size = 'small' }: TaskStatusChipProps): JSX.Element {
  return (
    <Chip
      data-testid="task-status-chip"
      label={formatTaskStatus(status, t)}
      color={STATUS_COLORS[status]}
      size={size}
      variant="outlined"
    />
  );
}
